import { PixelRatio } from "react-native";

import { isIOS } from "@/utils/platform.util";

const getResponsiveBottomPadding = (height: number): number => {
  if (isIOS()) {
    // Fixed across all iOS devices after testing on different iPhones
    return 100;
  }

  // Android logic: use percentage-based calculation with pixel density adjustment
  const androidBasePaddingPercentage = 0.5;
  const devicePixelRatio = PixelRatio.get();
  const referenceDensity = 3;
  const minScale = 0.85;
  const maxScale = 1.4;

  const rawScale = devicePixelRatio / referenceDensity;
  let effectiveScale = rawScale;

  if (rawScale < minScale) {
    effectiveScale = minScale;
  } else if (rawScale > maxScale) {
    effectiveScale = maxScale;
  }

  const paddingPercentage = androidBasePaddingPercentage * effectiveScale;
  return Math.round(height * paddingPercentage);
};

export { getResponsiveBottomPadding };
